export const Theme = {
    PRIMARY: '#215DAA',
    TEXT_PRIMARY_BLACK: '#262626',
    TEXT_PRIMARY: '#215DAA',
    BACKGROUND_PRIMARY: '#F8FAFB',
    ICONS_PRIMARY: '#E8E8E8',
    MENU_ICONS_ACTIVE: '#FFFFFF',
    SECONDARY: '#83CFA4',
    DISABLED_TEXT: "#676767",
    PRIMARY_BORDER: "#BEBEBE",
    TEXT_WHITE: '#FFFFFF',
    GREEN_BORDER_COLOR: "#83CFA4",
    WHITE_BACKGROUND: "#FFFFFF",
    ERROR_TEXT: "#EE5252",
    WARNING_TEXT: "#FFC107",
    SUCCESS: "green",
    DANGER: "#E05243",
    DISABLED_INPUT: "#f0f0f0",
    TEXT_DARK_GRAY: "#676767",
    GREEN_TEXT: "#0E9247",
    ERROR_BACKGROUND: "#F4ABAB",
}

export const KEYBOARD_EVENT_KEYS = {
    ARROWUP: "ArrowUp",
    ARROWDOWN: "ArrowDown",
    ENTER: "Enter"
}